import React from "react";
import styled from "styled-components";
import { inter, primaryBlack, primaryPink, white } from "../../Theme";
import {ReactComponent as ChevronRight} from '../../resources/icons/chevron_right.svg';
import {useHistory} from "react-router-dom";
import {getFormattedDateFromTimestamp} from "./ExamOverviewScreen";

function ExamOverviewCard(props) {
    const history = useHistory();

    return (
        <ExamCardRoot>
            <ExamCardTitle>{!!props.title ? props.title : "Toets"}</ExamCardTitle>

            <ExamCardParagraph>
                <ExamCardParagraphTitle>
                    Hoofdstukken:
                </ExamCardParagraphTitle>
                {props.exam.chapters}
            </ExamCardParagraph>

            <ExamCardParagraph>
                <ExamCardParagraphTitle>
                    Paragrafen:
                </ExamCardParagraphTitle>
                {props.exam.paragraphs}
            </ExamCardParagraph>

            <ExamCardParagraph>
                <ExamCardParagraphTitle>
                    Datum:
                </ExamCardParagraphTitle>
                {!!props.exam.date ? getFormattedDateFromTimestamp(props.exam.date) : ''}
            </ExamCardParagraph>

            <ExamCardViewScheduleButton onClick={() => history.push("/toets/" + props.exam.id, {exam: props.exam})}>
                <ExamCardViewScheduleButtonText>Bekijk planning</ExamCardViewScheduleButtonText>
                <ExamCardViewScheduleButtonChevron>
                    <StyledChevronRight />
                </ExamCardViewScheduleButtonChevron>

            </ExamCardViewScheduleButton>
        </ExamCardRoot>
    );
}

export const ExamCardRoot = styled.div`
    min-height: 193px;
    background: ${white};
    padding: 20px 20px 0 20px;
    //border-radius: 3px;
    //border: solid rgba(86, 89, 146, 0.1);
    //border-width: 1px 1px 3px 1px ;
    display: flex;
    flex-direction: column;
    p:last-of-type {
        margin-bottom: 20px;
    }
`;

export const ExamCardTitle = styled.h2`
    font-family: ${inter};
    font-size: 1.125em;
    font-weight: 700;
    color: ${primaryBlack};
    margin: 0 0 13px 0;
    padding: 0;
`;

export const ExamCardParagraph = styled.p`
    font-family: ${inter};
    font-weight: 400; 
    margin: 0 0 5px 0;
`;

export const ExamCardParagraphTitle = styled.span`
    opacity: 0.6;
    font-family: ${inter};
    margin-right: 5px;
`;

export const ExamCardViewScheduleButton = styled.a`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: auto;
    border-top: 1px solid rgba(79, 18, 58, 0.1);
    padding: 10px 0 10px 0;
    text-decoration: none;
    &:hover {
        cursor: pointer;
    }
`;

export const ExamCardViewScheduleButtonText = styled.span`
    font-family: ${inter};
    font-weight: 700;
    color: ${primaryPink};
`;

export const ExamCardViewScheduleButtonChevron = styled.div`
    justify-self: flex-end;
`;

const StyledChevronRight = styled(ChevronRight)`
    width: 14px;
    height: 14px;
    color: ${primaryPink};
`;

export default ExamOverviewCard;